// App.js
import {React, useRef, useContext} from 'react';
import { BrowserRouter, Route, Switch, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Tryitout from './pages/TryItOut';



const App = () => {

  return (
    <BrowserRouter>
      <Routes>
      
      <Route path='/' element={<Home />} />
      <Route path='/about' element={<About />} />
      <Route path='/tryitout' element={<Tryitout />} />

      
      </Routes>
    </BrowserRouter>
  );
};

export default App;
